<template>
  <div class="new-request__body">
    <div class="new-row">
      <div
        class="request-order__tab"
        :class="{ativo: this.request.STATE_request.activeRequestOrderTab === 'products' }"
        @click="onClickOrderTab('products')"
      >
        <icon
          name="product-box"
          :color="this.request.STATE_request.activeRequestOrderTab === 'products' ? '#4d76c8' : '#73777B'"
        />
        <span class="margin-left-min">Produtos</span>
        <div class="dot"></div>
        <span
          :class="{ has: getTotalRequestOrderProducts > 0 }"
          v-if="request.requestOrder"
        >{{ getTotalRequestOrderProducts }}</span>
      </div>
      <div
        v-if="!request.zepplinId"
        class="request-order__tab"
        :class="{ ativo: this.request.STATE_request.activeRequestOrderTab === 'services', 'top-right-rounded': !utils.isPersistedId(this.request.requestContact.contactId) }"
        @click="onClickOrderTab('services')"
      >
        <icon
          name="service-box"
          :color="this.request.STATE_request.activeRequestOrderTab === 'services' ? '#4d76c8' : '#73777B'"
        />
        <span class="margin-left-min">Serviços</span>
        <div class="dot"></div>
        <span
          :class="{ has: getTotalRequestOrderServices > 0 }"
          v-if="request.requestOrder"
        >{{ getTotalRequestOrderServices }}</span>
      </div>
      <div
        v-if="!request.zepplinId"
        class="request-order__tab"
        v-show="utils.isPersistedId(this.request.requestContact.contactId)"
        :class="{ativo: this.request.STATE_request.activeRequestOrderTab === 'history' }"
        @click="onClickOrderTab('history')"
      >
        <icon
          name="historic"
          :color="this.request.STATE_request.activeRequestOrderTab === 'history' ? '#4d76c8' : '#73777B'"
        />
        <span class="margin-left-min">Histórico de compras</span>
      </div>
      <div
        class="request-order__tab"
        :class="{ativo: this.request.STATE_request.activeRequestOrderTab === 'chat' }"
        v-if="utils.isPersistedId(this.request.id)"
        @click="onClickOrderTab('chat')"
      >
        <icon
          name="chat"
          :color="(getUnreadRequestChatItems > 0) ? 'var(--font-color--terciary)' : (this.request.STATE_request.activeRequestOrderTab === 'chat' ? '#4d76c8' : '#73777B')"
        />
        <span
          v-if="getUnreadRequestChatItems > 0"
          class="margin-left-min"
          style="color: var(--font-color--terciary);"
        >Chat</span>
        <span v-else class="margin-left-min">Chat</span>
        <div
          v-if="getUnreadRequestChatItems > 0"
          class="dot"
          style="background-color: var(--font-color--terciary)"
        ></div>
        <span
          v-if="getUnreadRequestChatItems > 0"
          style="color: var(--font-color--terciary)"
        >{{ getUnreadRequestChatItems }}</span>
      </div>
      <span class="flex-grow"></span>
      <div
        v-if="utils.isPersistedId(this.request.id)"
        @click="generateReceipt()"
        style="cursor: pointer;"
      >
        <icon name="printer" width="20" height="20" />
      </div>
    </div>
    <div
      v-if="this.request.STATE_request.activeRequestOrderTab === 'products' && request && request.requestOrder"
    >
      <div :class="{ 'disabled': request.zepplinId }">
        <div class="request-section products__container">
          <table class="request-table" style="margin: 0 0">
            <thead>
              <tr class="tabela">
                <th class="th1">
                  <span class="span1">Produto</span>
                </th>
                <th class="th2">
                  <!-- <img :src="require('./Elements/ic-down.png')" v-if="cabecalho" /> -->
                </th>
                <th class="th3" style="float: right">
                  <span class="span2">Quantia</span>
                </th>
                <th class="th4"></th>
                <th class="th5" style="float: right">
                  <span class="span3">Valor</span>
                </th>
                <th class="th6">
                  <!-- <img :src="require('./Elements/ic-checkmark.png')" v-if="cabecalho" /> -->
                </th>
                <th class="th7" style="float: right">
                  <span class="span4">Des./Acr.</span>
                </th>
                <th class="th8"></th>
                <th class="th9" style="float: right">
                  <span class="span5">Subtotal</span>
                </th>
                <th class="th10">
                  <!-- <img style="cursor: pointer;"  :src="require('./Elements/ic-del.png')" v-if="cabecalho" /> -->
                </th>
              </tr>
            </thead>
            <tbody v-if="request.requestOrder">
              <tr
                v-for="requestOrderProduct in request.requestOrder.requestOrderProducts"
                :key="requestOrderProduct.id"
                style="height: 10px"
              >
                <td v-if="products && productSearchTerms.length > 0">
                  <!-- <app-select :value="requestOrderProduct" :downIcon="request.zepplinId ? false : true" :items="products" :popoverProps="{verticalOffset: 0, horizontalOffset: -15, placement: 'bottom-start'}" @input="selectOrderProduct(requestOrderProduct, $event)">
                                        <input type="text" class="select readonly" style="margin-bottom: 0; border: none; padding: 0" readonly :value="getProductName(requestOrderProduct.productId)"/>
                                        <template slot="item" slot-scope="slotProps">
                                            <span>{{ slotProps.text }}</span>
                                        </template>
                  </app-select>-->
                  <app-search
                    :items="products"
                    :horizontalOffset="-10"
                    style="width:100%;"
                    :forceVisible="productSearchTerms.find(searchTerm => searchTerm.id == requestOrderProduct.id) ? productSearchTerms.find(searchTerm => searchTerm.id == requestOrderProduct.id).forceVisible : false"
                    :value="getProductName(requestOrderProduct.productId)"
                    @select="selectOrderProduct(requestOrderProduct, $event.id)"
                    :notFoundMessage="'Nenhum produto encontrado.'"
                  >
                    <template v-slot:input>
                      <input
                        type="text"
                        autocomplete="nope"
                        class="select readonly"
                        style="margin-bottom: 0; border: none; padding: 0;"
                        :style="requestOrderProduct._isHit ? 'color: white' : 'color: #aaaaab'"
                        @focus="onFocusProductInput(requestOrderProduct)"
                        @blur="productSearchTerms.find(searchTerm => searchTerm.id == requestOrderProduct.id) ? productSearchTerms.find(searchTerm => searchTerm.id == requestOrderProduct.id).forceVisible = false : ''"
                        :value="productSearchTerms.find(searchTerm => searchTerm.id == requestOrderProduct.id) ? productSearchTerms.find(searchTerm => searchTerm.id == requestOrderProduct.id).value : ''"
                        placeholder="Busque por um produto"
                        @input="searchProducts($event.target.value, requestOrderProduct.id)"
                      />
                    </template>
                    <template v-slot:item="slotProps">
                      <div>
                        <div
                          :style="slotProps.item.id == requestOrderProduct.productId ? 'color: white' : ''"
                        >{{ slotProps.item.name }}</div>
                      </div>
                    </template>
                  </app-search>
                </td>
                <td></td>
                <td style="width: 60px">
                  <input
                    class="input"
                    type="text"
                    @input="updateModelValue(VXORM.RequestOrderProduct, 'quantity', requestOrderProduct.id, parseInt($event.target.value))"
                    :value="requestOrderProduct.quantity ? requestOrderProduct.quantity : 0"
                    style="width: 100%; margin-bottom: 0; text-align: right; padding: 0"
                  />
                </td>
                <td></td>
                <td style="width: 90px">
                  <money
                    class="input"
                    @input.native="updateMoneyValue(VXORM.RequestOrderProduct, 'unitPrice', requestOrderProduct.id, $event)"
                    :value="requestOrderProduct.unitPrice ? requestOrderProduct.unitPrice  : 0.00"
                    style="width: 100%; margin-bottom: 0; text-align: right; padding: 0"
                  ></money>
                </td>
                <td></td>
                <td style="width: 80px">
                  <money
                    class="input"
                    @input.native="updateMoneyValue(VXORM.RequestOrderProduct, 'unitDiscount', requestOrderProduct.id, $event)"
                    :value="requestOrderProduct.unitDiscount ? requestOrderProduct.unitDiscount : 0"
                    style="width: 100%; margin-bottom: 0; text-align: right; padding: 0;"
                  ></money>
                </td>
                <td></td>
                <td
                  style="width: 80px; padding-top: 10px; padding: 0 0 0 8px; text-align: right; margin-bottom: 5px"
                >
                  <span class="prefix-subtotal">R$</span>
                  {{ utils.getMoneyAsDecimal((requestOrderProduct.unitPrice - requestOrderProduct.unitDiscount) * requestOrderProduct.quantity) }}
                </td>
                <td v-if="!request.zepplinId" class="minus-div">
                  <div style="display: flex; flex-direction: row;">
                    <div
                      style="padding-left: 8px; cursor: pointer;"
                      @click="removeRequestOrderProduct(requestOrderProduct.id)"
                    >
                      <icon name="minus-square" />
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
          <div
            class="new-pedido-button"
            :class="{ 'total-products__zepplin': request.zepplinId }"
            style="display: flex; justify-content: space-between; align-items: flex-end"
          >
            <input
              v-if="!request.zepplinId"
              type="button"
              value="Incluir produto"
              @click="addNewRequestOrderProduct()"
            />
            <span class="total-wrap">
              Total
              <span class="total-value">
                <span>R$ {{ this.utils.formatMoney(getOrderProductsTotalPrice, 2, '', '.', ',') }}</span>
              </span>
            </span>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="this.request.STATE_request.activeRequestOrderTab === 'services' && request && request.requestOrder"
    >
      <div>
        <div class="request-section services__container">
          <table class="request-table" style="margin: 0 0">
            <thead>
              <tr class="tabela">
                <th class="th1">
                  <span class="span1">Serviço</span>
                </th>
                <th class="th2">
                  <!-- <img :src="require('./Elements/ic-down.png')" v-if="cabecalho" /> -->
                </th>
                <th class="th5" style="float: right">
                  <span class="span3">Valor</span>
                </th>
                <th class="th4"></th>
                <th class="th7" style="float: right">
                  <span class="span4">Des./Acr.</span>
                </th>
                <th class="th8"></th>
                <th class="th9" style="float: right">
                  <span class="span5">Subtotal</span>
                </th>
              </tr>
            </thead>
            <tbody v-if="request.requestOrder">
              <tr
                v-for="requestOrderService in request.requestOrder.requestOrderServices"
                :key="requestOrderService.id"
                style="height: 10px"
              >
                <td>
                  <app-search
                    :items="services"
                    :horizontalOffset="-10"
                    style="width:100%;"
                    :forceVisible="serviceSearchTerms.find(searchTerm => searchTerm.id == requestOrderService.id) ? serviceSearchTerms.find(searchTerm => searchTerm.id == requestOrderService.id).forceVisible : false"
                    :value="getServiceName(requestOrderService.serviceId)"
                    @select="selectOrderService(requestOrderService, $event.id)"
                    :notFoundMessage="'Nenhum produto encontrado.'"
                  >
                    <template v-slot:input>
                      <input
                        type="text"
                        autocomplete="nope"
                        class="select readonly"
                        style="margin-bottom: 0; border: none; padding: 0;"
                        :style="requestOrderService._isHit ? 'color: white' : 'color: #aaaaab'"
                        @focus="onFocusServiceInput(requestOrderService)"
                        @blur="serviceSearchTerms.find(searchTerm => searchTerm.id == requestOrderService.id).forceVisible = false"
                        :value="serviceSearchTerms.find(searchTerm => searchTerm.id == requestOrderService.id) ? serviceSearchTerms.find(searchTerm => searchTerm.id == requestOrderService.id).value : ''"
                        placeholder="Busque por um serviço"
                        @input="searchServices($event.target.value, requestOrderService.id)"
                      />
                    </template>
                    <template v-slot:item="slotProps">
                      <div>
                        <div
                          :style="slotProps.item.id == requestOrderService.serviceId ? 'color: white' : ''"
                        >{{ slotProps.item.name }}</div>
                      </div>
                    </template>
                  </app-search>
                </td>
                <td></td>
                <td style="width: 90px">
                  <money
                    class="input"
                    @input.native="updateMoneyValue(VXORM.RequestOrderService, 'price', requestOrderService.id, $event)"
                    :value="requestOrderService.price ? requestOrderService.price  : 0.00"
                    style="width: 100%; margin-bottom: 0; text-align: right; padding: 0"
                  ></money>
                </td>
                <td></td>
                <td style="width: 80px">
                  <money
                    class="input"
                    @input.native="updateMoneyValue(VXORM.RequestOrderService, 'discount', requestOrderService.id, $event)"
                    :value="requestOrderService.discount ? requestOrderService.discount : 0"
                    style="width: 100%; margin-bottom: 0; text-align: right; padding: 0;"
                  ></money>
                </td>
                <td></td>
                <td
                  style="width: 80px; padding-top: 10px; padding: 0 0 0 8px; text-align: right; margin-bottom: 5px"
                >
                  <span class="prefix-subtotal">R$</span>
                  {{ utils.getMoneyAsDecimal((requestOrderService.price - requestOrderService.discount)) }}
                </td>
                <td class="minus-div">
                  <div style="display: flex; flex-direction: row;">
                    <div
                      style="padding-left: 8px; cursor: pointer;"
                      @click="removeRequestOrderService(requestOrderService.id)"
                    >
                      <icon name="minus-square" />
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
          <div class="new-pedido-button" style="display: flex; justify-content: space-between; align-items: flex-end">
            <input type="button" value="Incluir serviço" @click="addNewRequestOrderService()" />
            <span class="total-wrap">
              Total
              <span style="total-value">
                <span>R$ {{ this.utils.formatMoney(getOrderServicesTotalPrice, 2, '', '.', ',') }}</span>
              </span>
            </span>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="this.request.STATE_request.activeRequestOrderTab !== 'history' && this.request.STATE_request.activeRequestOrderTab !== 'chat' && request.requestOrder"
    >
      <div class="request-section" :class="{ 'disabled': request.zepplinId }">
        <table class="tabela-02" style="margin: 0">
          <tr class="tabela">
            <th class="th1">
              <span class="span1">Forma de pagamento</span>
            </th>
            <th class="th2">
            </th>
            <th class="th3">
              <span class="span2">Número</span>
            </th>
            <th class="th4"></th>
            <th class="th5 text-right">
              <span class="span3">Vencimento</span>
            </th>
            <th class="th6">
            </th>
            <th class="th8"></th>
            <th class="th9" style="float: right">
              <span class="span5">A receber</span>
            </th>
            <th class="th10">
              <!-- <img style="cursor: pointer;"  :src="require('./Elements/ic-del.png')" v-if="cabecalho" /> -->
            </th>
          </tr>
          <tbody v-if="request.requestOrder">
            <tr
              v-for="requestOrderPayment in request.requestOrder.requestOrderPayments"
              :key="requestOrderPayment.id"
              style="height: 10px"
            >
              <td>
                <app-select
                  class="payment-select"
                  :items="getPaymentMethods"
                  :downIcon="request.zepplinId ? false : true"
                  :popoverProps="{verticalOffset: 0, horizontalOffset: -15, placement: 'bottom-start'}"
                  @input="selectRequestOrderPayment(requestOrderPayment, $event)"
                >
                  <input
                    type="text"
                    class="select readonly"
                    style="margin-bottom: 0; border: none; padding: 0"
                    readonly
                    :value="getPaymentMethodName(requestOrderPayment.paymentMethodId)"
                  />
                  <template slot="item" slot-scope="slotProps">
                    <span>{{ slotProps.text }}</span>
                  </template>
                </app-select>
              </td>
              <td></td>
              <td style="width: 80px">
                <div
                  v-if="requestOrderPayment.paymentMethod && requestOrderPayment.paymentMethod.hasDeadline"
                >
                  <input
                    class="input"
                    type="text"
                    @input="updateModelValue(VXORM.RequestOrderPayment, 'code', requestOrderPayment.id, $event.target.value)"
                    :value="requestOrderPayment.code ? requestOrderPayment.code : ''"
                    style="width: 100%; margin-bottom: 0; text-align: left; padding: 0;"
                  />
                </div>
                <div v-else>
                  <span>---</span>
                </div>
              </td>
              <td></td>
              <td style="width: 90px">
                <div
                  v-if="requestOrderPayment.paymentMethod && requestOrderPayment.paymentMethod.hasDeadline"
                >
                  <app-datetime-selector
                    style="width: 100%; padding: 0; margin: 0;"
                    class="input no-margin-bottom no-padding align-right"
                    :value="requestOrderPayment.deadlineDatetime"
                    @input="updateModelValue(VXORM.RequestOrderPayment, 'deadlineDatetime', requestOrderPayment.id, $event)"
                    :config="datetimeSelectorConfig"
                    placeholder="##/##/####"
                  ></app-datetime-selector>
                </div>
                <div v-else style="display: flex; align-items: center; flex-direction: column">
                  <div>---</div>
                </div>
              </td>
              <td
                style="float: right; width: 20px; height: 30px; position: relative; top: 5px; cursor: pointer"
                @click="toggleReceived(requestOrderPayment)"
              >
                <div v-if="requestOrderPayment.received">
                  <icon-request-check></icon-request-check>
                </div>
                <div v-else>
                  <icon-request-not-check></icon-request-not-check>
                </div>
              </td>
              <td></td>
              <td style="width: 80px">
                <money
                  class="input"
                  @input.native="updateMoneyValue(VXORM.RequestOrderPayment, 'amount', requestOrderPayment.id, $event)"
                  :value="requestOrderPayment.amount"
                  style="width: 100%; text-align: right; margin: 0; padding: 0"
                ></money>
              </td>
              <td v-if="!request.zepplinId" class="minus-div">
                <div style="display: flex; flex-direction: row;">
                  <div
                    style="margin-left: 8px; cursor: pointer;"
                    @click="removeRequestOrderPayment(requestOrderPayment.id)"
                  >
                    <icon name="minus-square" />
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
        <div
          v-if="!request.zepplinId"
          class="new-pedido-button"
          :class="{ 'total-products__zepplin': request.zepplinId }"
          style="display: flex; justify-content: space-between; align-items: flex-end"
        >
          <input type="button" value="Incluir pagamento" @click="addNewRequestOrderPayment()" />
          <span style="font-family: Arial, Helvetica, sans-serif;font-size: 14px;color: #73777B;">
            <div id="request-payment-info" class="row align-center">
              <div class="request-payment-info-item">
                <div class="received-content">
                  Recebeu
                  <span class="received-value blue-text">{{ getReceived }}</span>
                </div>
              </div>
              <div class="request-payment-info-item">
                <div class="balance-content">
                  Saldo
                  <span class="balance-value orange-text">
                    R$ {{ getBalance }}
                  </span>
                </div>
              </div>
            </div>
          </span>
        </div>
      </div>

      <div v-if="request.zepplinId" class="request-section disabled">
        <div style="display: flex; justify-content: space-between; align-items: center;">
          <span
            style="width: 100%; flex-basis: 130px; font-family: Arial, Helvetica, sans-serif;font-size: 14px;margin: 0px 5px;color: #73777B;"
          >Taxa de entrega</span>
          <money
            class="input"
            @input.native="updateMoneyValue(VXORM.Request, 'deliveryTax', request.id, $event)"
            :value="request.deliveryTax ? request.deliveryTax : 0"
            style="width: 100%; text-align: right; margin: 0; padding: 0"
          ></money>
        </div>
      </div>

      <div class="new-pedido-card" :class="{ 'disabled': request.zepplinId }">
        <div
          class="request-section"
          :class="{ 'request-obs__zepplin': request.zepplinId }"
          style="flex-grow: 0; height:50px; width: 50%;"
        >
          <div class="observations-wrap"><span class="section-title">Observações</span>
            <textarea
              v-if="request.zepplinId"
              class="input observations-text-area"
              name="obs"
              cols="10"
              rows="3"
              :value="getRequestOrder.obs"
            ></textarea>
            <input
              v-else
              type="text"
              class="input observations-input"
              @input="updateModelValue(VXORM.RequestOrder, 'obs', request.requestOrderId, $event.target.value)"
              :value="getRequestOrder.obs"
            />
          </div>
        </div>

        <div
          class="request-section"
          :class="{ 
                        'zepplin-request-deliveryDate': (request.zepplinId && !request.isScheduled && request.STATE_request.persistedStatus === 'pending') 
                    }"
          :style="{ height: request.zepplinId ? '80px' : '50px' }"
          style="margin-left:10px; width: 50%; display: flex; flex-direction: column; justify-content: space-between; align-items: center;"
        >
          <div v-if="request.zepplinId">
            <span
              style="font-style: italic; width: 100%; flex-basis: 130px; font-family: Arial, Helvetica, sans-serif;font-size: 13px; margin: 0px 5px;color: #73777B;"
            >pedido feito às {{ moment(request.dateCreated).local().format('DD/MM/YYYY HH:mm') }}</span>
          </div>
          <div
            style="flex-grow: 1;height:50px; width: 100%; display: flex; justify-content: space-between; align-items: center;"
          >
            <span class="section-title">Entrega {{ request.deliveryDate && !request.isScheduled ? 'até' : '' }}</span>
            <div
              @click="updateRequestDeliveryDateOnClick()"
              :class="{ 'enabled': (!request.isScheduled && request.STATE_request.persistedStatus === 'pending')  }"
              style="width: 100%; display: flex; align-items: center;"
            >
              <app-datetime-selector
                class="delivery-date-input input-select"
                :value="request.deliveryDate ? moment(request.deliveryDate).local().format() : null"
                @input="onDeliveryDateChange($event)"
                :config="deliveryDateSelectorConfig"
                :placeholder="!request.zepplinId ? `em ${getDeliveryTime} minutos` : 'selecione para prosseguir'"
              ></app-datetime-selector>
              <fa
                v-if="!request.zepplinId"
                icon="times"
                size="sm"
                @click="cleanDatetimeSelector()"
                style="cursor: pointer; margin-right: 2px; margin-left: 5px;"
              />
            </div>
          </div>
        </div>
      </div>
      <div v-if="!request.zepplinId" class="align-between">
        <div class="request-section section-wrap">
          <div class="row">
            <span class="section-title">Canal de divulgação</span>
            <app-select
              class="flex-grow"
              :items="getPromotionChannels"
              :downIcon="true"
              :popoverProps="{verticalOffset: 0, horizontalOffset: -15, placement: 'bottom-start'}"
              @input="VXORM.RequestOrder.update({
                                where: request.requestOrderId,
                                data: { promotionChannelId: $event }
                            })"
            >
              <input
                type="text"
                class="promotion-channels-input select readonly"
                readonly
                :value="getPromotionChannel"
              />
              <template slot="item" slot-scope="slotProps">
                <span>{{ slotProps.text }}</span>
              </template>
            </app-select>
          </div>
        </div>
        <div v-if="isCallerId" class="request-section section-wrap">
          <div class="row">
            <span class="section-title">Onde o cliente ligou</span>
            <app-select
              class="flex-grow"
              :items="getPhoneLines"
              :downIcon="true"
              :popoverProps="{verticalOffset: 0, horizontalOffset: -15, placement: 'bottom-start'}"
              @input="selectPhoneLine($event)"
            >
              <input
                type="text"
                class="phone-lines-input select readonly"
                readonly
                :value="getPhoneLine"
              />
              <template slot="item" slot-scope="slotProps">
                <span>{{ slotProps.text }}</span>
              </template>
            </app-select>
          </div>
        </div>
      </div>
    </div>
    <app-request-history
      v-if="this.request.STATE_request.activeRequestOrderTab === 'history'"
      :request="request"
      @updateRequestOrder="updateRequestOrder($event)"
      style="flex-grow: 1; position: relative; display: flex;"
    />
    <app-request-chat
      v-if="this.request.STATE_request.activeRequestOrderTab === 'chat' && !this.request.STATE_request.loading.show"
      :request="request"
      style="flex-grow: 1; position: relative; display: flex;"
    />
  </div>
</template>

<script>
import { Portuguese } from "flatpickr/dist/l10n/pt";
import shortid from "shortid";
import moment from "moment";
import * as FileSaver from "file-saver";

import RequestHistoryComponent from "./RequestHistory";
import RequestChatComponent from "./RequestChat";
import SearchComponent from "../../../../../components/Inputs/Search";

import ReceiptHelper from "../../../../../helpers/ReceiptHelper";
import { mapState, mapActions } from "vuex";

import ProductsAPI from "../../../../../api/products";
import ServicesAPI from "../../../../../api/services";

export default {
  props: ["request"],
  mixins: [ReceiptHelper],
  components: {
    "app-request-history": RequestHistoryComponent,
    "app-request-chat": RequestChatComponent,
    "app-search": SearchComponent
  },
  data() {
    return {
      datetimeSelectorConfig: {
        altInput: true,
        altFormat: "d/m/Y",
        dateFormat: "Z",
        locale: Portuguese,
        time_24hr: true,
        enableTime: true
      },
      deliveryDateSelectorConfig: {
        altInput: true,
        altFormat: "d/m/Y H:i",
        dateFormat: "Z",
        defaultHour: this.request.zepplinId
          ? moment()
              .add(
                this.VXORM.CompanySetting.query()
                  .where("key", "estimatedDeliveryTime")
                  .first()
                  ? this.VXORM.CompanySetting.query()
                      .where("key", "estimatedDeliveryTime")
                      .first().value
                  : 20,
                "minutes"
              )
              .hour()
          : "12",
        defaultMinute: this.request.zepplinId
          ? moment()
              .add(
                this.VXORM.CompanySetting.query()
                  .where("key", "estimatedDeliveryTime")
                  .first()
                  ? this.VXORM.CompanySetting.query()
                      .where("key", "estimatedDeliveryTime")
                      .first().value
                  : 20,
                "minutes"
              )
              .minute()
          : "00",
        locale: Portuguese,
        time_24hr: true,
        enableTime: true,
        noCalendar: this.request.zepplinId ? true : false,
        minTime: this.request.zepplinId
          ? moment(this.request.dateCreated)
              .local()
              .format("HH:mm")
          : false
      },
      products: [],
      productSearchTerms: [],
      services: [],
      serviceSearchTerms: []
    };
  },
  computed: {
    ...mapState("auth", ["company"]),
    getDeliveryTime() {
      const estimatedDeliveryTime = this.VXORM.CompanySetting.query()
        .where("key", "estimatedDeliveryTime")
        .first();
      return estimatedDeliveryTime ? estimatedDeliveryTime.value : 20;
    },
    getUnreadRequestChatItems() {
      return _.result(
        this.request,
        "STATE_request.card.unreadRequestChatItems",
        0
      );
    },
    getTotalRequestOrderProducts() {
      let quantity = 0;
      this.request.requestOrder.requestOrderProducts.forEach(value => {
        if (Number.isSafeInteger(value.productId)) quantity += value.quantity;
      });
      return quantity;
    },
    getTotalRequestOrderServices() {
      let quantity = 0;
      this.request.requestOrder.requestOrderServices.forEach(value => {
        if (Number.isSafeInteger(value.serviceId)) quantity += 1;
      });
      return quantity;
    },
    getPaymentMethods() {
      return this.VXORM.PaymentMethod.query()
        .where("status", "active")
        .get()
        .map(paymentMethod => {
          return { value: paymentMethod.id, text: paymentMethod.name };
        });
    },
    getPromotionChannels() {
      return this.VXORM.PromotionChannel.query()
        .where("status", "active")
        .get()
        .map(promotionChannel => {
          return { value: promotionChannel.id, text: promotionChannel.name };
        });
    },
    getPromotionChannel() {
      const promotionChannel = this.VXORM.PromotionChannel.query().find(
        _.result(this.request, "requestOrder.promotionChannelId", null)
      );
      return promotionChannel ? promotionChannel.name : "SELECIONE";
    },
    getPhoneLines() {
      return this.VXORM.PhoneLine.query()
        .where("status", "active")
        .get()
        .map(phoneLine => {
          return { value: phoneLine.id, text: phoneLine.name };
        });
    },
    getPhoneLine() {
      return Number.isInteger(this.request.phoneLineId)
        ? this.VXORM.PhoneLine.query()
            .where("id", this.request.phoneLineId)
            .first().name
        : "Sem linha";
    },
    getRequestOrderPayments() {
      return this.VXORM.RequestOrderPayment.query()
        .where("requestOrderId", this.request.requestOrderId)
        .get();
    },
    getRequestOrderProducts() {
      return this.VXORM.RequestOrderProduct.query()
        .where("requestOrderId", this.request.requestOrderId)
        .get();
    },
    getRequestOrder() {
      return this.VXORM.RequestOrder.query()
        .where("id", this.request.requestOrderId)
        .first();
    },
    getRequest() {
      return this.VXORM.Request.query()
        .where("id", this.request.id)
        .first();
    },
    getOrderTotalPrice() {
      let totalPriceServices = this.getOrderProductsTotalPrice;
      let totalPriceProducts = this.getOrderServicesTotalPrice;
      return this.utils.formatMoney(
        totalPriceProducts + totalPriceServices,
        2,
        "",
        ".",
        ","
      );
    },
    getOrderProductsTotalPrice() {
      return _.sumBy(
        this.VXORM.RequestOrderProduct.query()
          .where("requestOrderId", this.request.requestOrderId)
          .get()
          .filter(requestOrderProduct => {
            return requestOrderProduct.productId;
          }),
        requestOrderProduct => {
          return (
            (requestOrderProduct.unitPrice - requestOrderProduct.unitDiscount) *
            requestOrderProduct.quantity
          );
        }
      );
    },
    getOrderServicesTotalPrice() {
      return _.sumBy(
        this.VXORM.RequestOrderService.query()
          .where("requestOrderId", this.request.requestOrderId)
          .get()
          .filter(requestOrderService => {
            return requestOrderService.serviceId;
          }),
        requestOrderService => {
          return requestOrderService.price - requestOrderService.discount;
        }
      );
    },
    getReceived() {
      let amount = 0;
      this.request.requestOrder.requestOrderPayments.forEach(payment => {
        if (payment.received) amount += parseFloat(payment.amount);
      });
      return this.utils.formatMoney(amount, 2, "R$ ", ".", ",");
    },
    getBalance() {
      let amount = 0;
      let requestOrderPaymentReceiveds = this.request.requestOrder.requestOrderPayments.filter(
        requestOrderPayment => requestOrderPayment.received
      );
      if (requestOrderPaymentReceiveds.length == 0)
        return this.getOrderTotalPrice;

      amount +=
        parseFloat(this.getOrderTotalPrice.replace(",", ".")) -
        parseFloat(
          this.getReceived
            .replace(",", ".")
            .replace("R$", "")
            .trim()
        );
      return this.utils.formatMoney(amount, 2, "", ".", ",");
    },

    isCallerId() {
      return this.VXORM.CompanySetting.query()
        .where(
          companySetting =>
            companySetting.key === "isCallerId" &&
            companySetting.value === "true"
        )
        .first();
    }
  },
  methods: {
    ...mapActions("toast", ["showToast", "showError"]),
    onFocusProductInput(requestOrderProduct) {
      const index = this.productSearchTerms.findIndex(
        searchTerm => searchTerm.id == requestOrderProduct.id
      );
      if (index === -1) return;
      this.productSearchTerms[index].forceVisible = true;
      return this.setProducts(
        requestOrderProduct._isHit ? null : this.productSearchTerms[index].value
      );
    },

    onFocusServiceInput(requestOrderService) {
      const index = this.serviceSearchTerms.findIndex(
        searchTerm => searchTerm.id == requestOrderService.id
      );
      if (index === -1) return;
      this.serviceSearchTerms[index].forceVisible = true;
      return this.setServices(
        requestOrderService._isHit ? null : this.serviceSearchTerms[index].value
      );
    },

    async setProducts(searchTerm, retries = 0) {
      try {
        this.products = await ProductsAPI.getList({
          searchTerm,
          limit: 10,
          onlyActive: true
        }).then(res => res.data);
      } catch (err) {
        if (retries <= 3)
          return setTimeout(() => this.setProducts(retries + 1), 6000);
        console.error(err);
        this.showError("Não foi possível carregar os produtos.");
      }
    },

    async searchProducts(value, requestOrderProductId) {
      const index = this.productSearchTerms.findIndex(
        productSearchTerm => productSearchTerm.id == requestOrderProductId
      );
      this.productSearchTerms[index].value = value;
      const productSearchTerm = this.productSearchTerms[index];

      if (this.searchProductsTimeout) clearTimeout(this.searchProductsTimeout);
      this.searchProductsTimeout = setTimeout(() => {
        const product = this.products.find(
          product => product.name === productSearchTerm.value.trim()
        );
        if (product)
          this.VXORM.RequestOrderProduct.update({
            where: requestOrderProductId,
            data: { productId: product.id, _isHit: true }
          });
        else {
          this.VXORM.RequestOrderProduct.update({
            where: requestOrderProductId,
            data: { productId: null, _isHit: false }
          });
        }

        this.setProducts(productSearchTerm.value.trim());
      }, 500);
    },

    async setServices(searchTerm, retries = 0) {
      try {
        this.services = await ServicesAPI.getList({
          searchTerm,
          limit: 10,
          onlyActive: true
        }).then(res => res.data);
      } catch (err) {
        if (retries <= 3) return this.setServices(retries + 1);
        console.error(err);
        this.showError("Não foi possível carregar os serviços.");
      }
    },

    async searchServices(value, requestOrderServiceId) {
      const index = this.serviceSearchTerms.findIndex(
        serviceSearchTerm => serviceSearchTerm.id == requestOrderServiceId
      );
      this.serviceSearchTerms[index].value = value;
      const serviceSearchTerm = this.serviceSearchTerms[index];

      if (this.searchProductsTimeout) clearTimeout(this.searchProductsTimeout);
      this.searchProductsTimeout = setTimeout(() => {
        const service = this.services.find(
          service => service.name === serviceSearchTerm.value.trim()
        );
        if (service)
          this.VXORM.RequestOrderService.update({
            where: requestOrderServiceId,
            data: { serviceId: service.id, _isHit: true }
          });
        else {
          this.VXORM.RequestOrderService.update({
            where: requestOrderServiceId,
            data: { serviceId: null, _isHit: false }
          });
        }

        this.setServices(serviceSearchTerm.value.trim());
      }, 500);
    },

    getProductName(productId) {
      let _product = this.products.find(product => product.id == productId);
      const requestOrderProduct = _.get(
        this.request,
        "requestOrder.requestOrderProducts"
      ).find(requestOrderProduct => requestOrderProduct.productId == productId);
      const product = _product
        ? _product
        : requestOrderProduct
        ? requestOrderProduct.product
        : null;

      return product ? product.name : null;
    },

    getServiceName(serviceId) {
      let _service = this.services.find(service => service.id == serviceId);
      const requestOrderService = _.get(
        this.request,
        "requestOrder.requestOrderServices"
      ).find(requestOrderService => requestOrderService.serviceId == serviceId);
      const service = _service
        ? _service
        : requestOrderService
        ? requestOrderService.service
        : null;

      return service ? service.name : null;
    },

    getPaymentMethodName(paymentMethodId) {
      return Number.isInteger(paymentMethodId)
        ? this.VXORM.PaymentMethod.query()
            .where("id", paymentMethodId)
            .first().name
        : "SELECIONE";
    },
    addNewRequestOrderProduct() {
      const tmpId = `tmp/${shortid.generate()}`;
      this.productSearchTerms.push({
        id: tmpId,
        value: null,
        forceVisible: false
      });
      this.VXORM.RequestOrderProduct.insert({
        data: {
          id: tmpId,
          requestOrderId: this.request.requestOrderId,
          productId: `tmp/${shortid.generate()}`
        }
      });
    },
    addNewRequestOrderService() {
      const tmpId = `tmp/${shortid.generate()}`;
      this.serviceSearchTerms.push({
        id: tmpId,
        value: null,
        forceVisible: false
      });
      this.VXORM.RequestOrderService.insert({
        data: {
          id: tmpId,
          requestOrderId: this.request.requestOrderId,
          serviceId: `tmp/${shortid.generate()}`
        }
      });
    },
    addNewRequestOrderPayment() {
      let requestOrderPaymentTmpId = `tmp/${shortid.generate()}`;
      this.VXORM.RequestOrderPayment.insert({
        data: {
          id: requestOrderPaymentTmpId,
          requestOrderId: this.request.requestOrderId,
          paymentMethodId: `tmp/${shortid.generate()}`
        }
      });
    },
    removeRequestOrderProduct(requestOrderProductId) {
      if (this.request.requestOrder.requestOrderProducts.length <= 1)
        this.addNewRequestOrderProduct();
      this.VXORM.RequestOrderProduct.delete(requestOrderProductId);
      _.remove(
        this.productSearchTerms,
        productSearchTerm => productSearchTerm.id == requestOrderProductId
      );
    },
    removeRequestOrderService(requestOrderServiceId) {
      if (this.request.requestOrder.requestOrderServices.length <= 1)
        this.addNewRequestOrderService();
      this.VXORM.RequestOrderService.delete(requestOrderServiceId);
      _.remove(
        this.serviceSearchTerms,
        serviceSearchTerm => serviceSearchTerm.id == requestOrderServiceId
      );
    },
    removeRequestOrderPayment(requestOrderPaymentId) {
      if (this.request.requestOrder.requestOrderPayments.length <= 1)
        this.VXORM.RequestOrderPayment.insert({
          data: {
            id: `tmp/${shortid.generate()}`,
            requestOrderId: this.request.requestOrderId,
            amount: parseFloat(this.getBalance.replace(",", ".")).toFixed(2)
          }
        });
      this.VXORM.RequestOrderPayment.delete(requestOrderPaymentId);
    },
    updateModelValue(modelVXORM, fieldName, modelId, valueToUpdate) {
      this.VXORM.Request.updateModelValue(
        modelVXORM,
        fieldName,
        modelId,
        valueToUpdate
      );
    },
    updateMoneyValue(modelVXORM, fieldName, modelId, event) {
      if (event.isTrusted)
        this.VXORM.Request.updateModelValue(
          modelVXORM,
          fieldName,
          modelId,
          this.utils.getMoneyAsDecimal(
            event.target.value ? event.target.value : 0
          )
        );
    },
    selectPhoneLine(phoneLineId) {
      this.request.STATE_request.$update({
        where: this.request.STATE_request.id,
        data: { phoneLineId }
      });
      this.request.$update({ where: this.request.id, data: { phoneLineId } });
    },
    selectOrderProduct(requestOrderProduct, productId) {
      const productSearchTermIndex = this.productSearchTerms.findIndex(
        productSearchTerm => productSearchTerm.id == requestOrderProduct.id
      );
      if (productSearchTermIndex === -1) return;
      const product = this.products.find(product => product.id == productId);
      this.VXORM.RequestOrderProduct.update({
        where: requestOrderProduct.id,
        data: {
          productId: product.id,
          unitPrice: product.price,
          _isHit: true
        }
      });
      this.productSearchTerms[
        productSearchTermIndex
      ].value = this.getProductName(productId);
    },
    selectOrderService(requestOrderService, serviceId) {
      const serviceSearchTermIndex = this.serviceSearchTerms.findIndex(
        serviceSearchTerm => serviceSearchTerm.id == requestOrderService.id
      );
      if (serviceSearchTermIndex === -1) return;
      const service = this.services.find(service => service.id == serviceId);
      this.VXORM.RequestOrderService.update({
        where: requestOrderService.id,
        data: {
          serviceId: service.id,
          price: service.price
        }
      });
      this.serviceSearchTerms[
        serviceSearchTermIndex
      ].value = this.getServiceName(serviceId);
    },
    selectRequestOrderPayment(requestOrderPayment, paymentMethodId) {
      const currentPaymentMethod = this.VXORM.PaymentMethod.find(
        paymentMethodId
      );
      let requestOrderPaymentOptions = {};

      if (currentPaymentMethod) {
        if (
          _.isEmpty(requestOrderPayment.code) &&
          currentPaymentMethod.hasDeadline &&
          requestOrderPayment.code !== ""
        )
          requestOrderPaymentOptions.code = this.utils.getShortCode();
        else if (!currentPaymentMethod.hasDeadline)
          requestOrderPaymentOptions.code = null;

        if (currentPaymentMethod.hasDeadline) {
          requestOrderPaymentOptions.deadlineDatetime = currentPaymentMethod.deadlineRule
            ? moment(
                moment()
                  .local()
                  .add(parseInt(currentPaymentMethod.deadlineRule), "days")
              ).toISOString()
            : moment()
                .local()
                .toISOString();
        }
      }

      requestOrderPayment.$update({
        where: requestOrderPayment.id,
        data: {
          paymentMethodId,
          ...requestOrderPaymentOptions
        }
      });
    },

    updateRequestDeliveryDateOnClick() {
      const deliveryDate = this.request.zepplinId
        ? moment()
            .add(
              this.VXORM.CompanySetting.query()
                .where("key", "estimatedDeliveryTime")
                .first()
                ? this.VXORM.CompanySetting.query()
                    .where("key", "estimatedDeliveryTime")
                    .first().value
                : 20,
              "minutes"
            )
            .toISOString()
        : null;
      if (!deliveryDate) return;

      this.VXORM.Request.update({
        where: this.request.id,
        data: {
          deliveryDate
        }
      });
    },

    onDeliveryDateChange(value) {
      this.request.$update({
        where: this.request.id,
        data: {
          deliveryDate: value ? value : null,
          isScheduled: value && !this.request.zepplinId ? true : false
        }
      });
    },

    toggleReceived(requestOrderPayment) {
      this.updateModelValue(
        this.VXORM.RequestOrderPayment,
        "received",
        requestOrderPayment.id,
        !requestOrderPayment.received
      );
    },

    onClickOrderTab(tabName) {
      this.request.STATE_request.$update({
        where: this.request.STATE_request.id,
        data: {
          activeRequestOrderTab: tabName
        }
      });
    },

    cleanDatetimeSelector() {
      this.request.$update({
        where: this.request.id,
        data: {
          deliveryDate: null,
          isScheduled: false
        }
      });
    },

    generateReceipt() {
      const products = this.translateRequestOrderProductsToReceipt(
        this.request.requestOrder.requestOrderProducts
      );
      const paymentMethods = this.translateRequestOrderPaymentsToReceipt(
        this.request.requestOrder.requestOrderPayments
      );
      const contactAddress = this.translateContactAddressToReceipt(
        this.request.requestContact.contact.contactAddresses.find(
          contactAddress => contactAddress.isDefault
        )
      );
      const text = this.formatValues({
        requestCode: this.request.code,
        requestObs: this.getRequestOrder.obs,
        companyName: this.company.name,
        companyCnpj: null,
        products,
        paymentMethods,
        contactAddress,
        subtotal: this.getOrderTotalPrice,
        discount: "00,00",
        total: this.getOrderTotalPrice
          ? (parseFloat(this.getOrderTotalPrice.replace(",", ".")) - 0)
              .toFixed(2)
              .replace(".", ",")
          : "00,00",
        contactName: _.get(this.request, "requestContact.contact.name")
          ? this.request.requestContact.contact.name
          : "",
        contactCpf: _.get(this.request, "requestContact.contact.legalDocument")
          ? this.request.requestContact.contact.legalDocument
          : ""
      });

      var file = new File([text], `pedido-${this.request.code}`, {
        type: "text/plain;charset=utf-8"
      });
      FileSaver.saveAs(file);
    },

    async updateRequestOrder(request) {
      const _request = request;
      if (_.get(_request, "requestOrder.requestOrderProducts"))
        _request.requestOrder.requestOrderProducts.forEach(
          requestOrderProduct => {
            this.productSearchTerms.push({
              id: requestOrderProduct.id,
              value: this.getProductName(requestOrderProduct.productId),
              forceVisible: false
            });
          }
        );
      if (_.get(_request, "requestOrder.requestOrderServices"))
        _request.requestOrder.requestOrderServices.forEach(
          requestOrderService => {
            this.serviceSearchTerms.push({
              id: requestOrderService.id,
              value: this.getServiceName(requestOrderService.serviceId),
              forceVisible: false
            });
          }
        );

      if (!_request.zepplinId) {
        await this.setProducts();
        await this.setServices();
      }
    }
  },
  async mounted() {
    await this.updateRequestOrder(this.request);
  }
};
</script>

<style lang="scss" >
span {
  font-family: Arial, Helvetica, sans-serif;
}
.new-produtos {
  display: flex;
  flex-direction: row;
}
.new-historico {
  background: #23272b;
  border-radius: 2px;
  margin: 0px -10px 36px -10px;
}
.new-direita {
  display: flex;
  flex-direction: column;
  padding: 5px 0px 0px 0px;
}
.tabela-span {
  font-family: Arial, Helvetica, sans-serif;
  font-size: 14px;
  color: #73777b;
}
.ativo {
  font-family: Arial, Helvetica, sans-serif;
  font-size: 14px;
  color: #c3c5c6;
  .span5 {
    margin-left: -30px;
  }
  .span2 {
    margin-left: 15px;
  }
}
.request-section.products__container {
  background-color: #31363c;
}
.request-section.services__container {
  background-color: #31363c;
}
.request-section {
  height: auto;
  background: #23272b;
  margin: 0 0 10px 0;
  padding: 10px;
  border-radius: 2px;
  input[type="button"] {
    border: 0px;
    background: #4d76c8;
    border-radius: 2px;
    color: white;
    margin-top: 15px;
    height: 24px;
    cursor: pointer;
  }
  .th2 {
    img {
      margin-left: -5px;
      margin-right: 18px;
      padding-top: 5px;
    }
  }
  .th10 {
    img {
      margin-left: 10px;
      padding-top: 7px;
    }
  }
  .th6 {
    img {
      margin-left: -60px;
      margin-right: 18px;
      padding-top: 5px;
    }
  }
}
.new-pedido-card {
  display: flex;
  flex-direction: row;
  text-align: center;
}
.new-request__body {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  padding: 20px 10px 0px 10px;
  background: #161a1d;
  .new-style-span {
    display: flex;
    flex-direction: row;
    flex-grow: 1;
    padding: 0px;
    margin: 0px;
  }
}
.new-pedido-span {
  display: flex;
  flex-direction: row;
  float: right;
  margin: 20px 30px 0px 0px;
}
.new-pedido-input {
  margin: 15px 0px;
  height: 24px;
  width: 100px;
  background: #4d76c8;
  border: 0px;
  border-radius: 2px;
  color: #e7e8e8;
  font-size: 12px;
  cursor: pointer;
}
.new-row {
  display: flex;
  flex-direction: row;
  align-content: center;
}
.new-column {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
}
.comodato {
  padding: 7px 10px 5px 12px;
  background: #31363c;
  border-radius: 2px;
  font-family: Arial, Helvetica, sans-serif;

  font-size: 14px;
  height: 32px;
  cursor: pointer;
}
.produtos.ativo,
.historico.ativo,
.comodato.ativo {
  background: #23272b;
}
.new-pedido-button {
  span {
    font-size: 18px;
    color: #c3c5c6;
  }
}

.input-obs {
  background: transparent;
  border: 0;
  border-bottom: 1px solid rgb(115, 119, 123);
}

.prefix-subtotal {
  font-size: 0.6em;
}

.no-padding {
  padding: 0;
}

.input-select {
  padding: 0;
  margin: 0;
  width: 100%;
}
.input-select::placeholder {
  text-transform: uppercase;
  font-size: 0.8em;
}

.request-order__tab {
  display: flex;
  flex-direction: row;
  margin-right: 1px;

  padding: 7px 10px 5px 12px;
  background: #23272b;
  font-size: 14px;
  height: 32px;
  display: flex;
  cursor: pointer;
  span.has {
    color: #c3c5c6;
  }
  &.ativo {
    background-color: #31363c;
    span {
      color: #4d76c8;
    }
  }
  &:first-child {
    border-top-left-radius: 5px;
  }
  &:last-child {
    margin-right: 0;
    border-top-right-radius: 5px !important;
  }
}

.disabled {
  pointer-events: none;
}

.enabled {
  pointer-events: fill;
}

.total-products__zepplin {
  justify-content: flex-end !important;
  margin-top: 10px;
}

.request-obs__zepplin {
  height: 100px !important;
}

.zepplin-request-deliveryDate {
  border: 1px dashed #e0634a;
}

.payment-select {
  width: 88%;
}

.section-title {
  width: 40% !important; 
  flex-shrink: 0; 
  text-align: left; 
  font-family: Arial, Helvetica, sans-serif;
  font-size: 14px;
  margin-right: 5px;
  color: #73777B;
}

.row {
  display: flex;
}

.flex-grow {
  flex-grow: 1;
}

.align-center {
  align-items: center;
}

.text-right {
  text-align: right;
}

.margin-left-min {
  margin-left: 5px;
}

.orange-text {
  color: #E0634A !important;
}

.blue-text {
  color: #58BFC6 !important;
}

#request-payment-info {
  margin-right: 20px;
}

#request-payment-info .request-payment-info-item {
  padding: 3px 10px;
  border: 1px solid rgba(115, 119, 123, 0.5);
  border-radius: 2px;
  margin: 0 5px;
}

#request-payment-info .request-payment-info-item .received-content {
  font-family: Arial, Helvetica, sans-serif;
  font-size: 12px;
}

#request-payment-info .request-payment-info-item .balance-content {
  font-size: 12px;
}

.received-content .received-value {
  font-size: 16px;
}

.balance-content .balance-value {
  font-size: 16px;
}

.observations-wrap {
  display: flex; 
  justify-content: space-between; 
  align-items: center; 
  height: 100%;
}

.observations-text-area {
  width: 100%; 
  font-family: Arial, Helvetica, sans-serif; 
  font-size: 13px; 
  color: #E7E8E8; 
  margin: 0px 15px 0px 0px;
}

.observations-input {
  width: 100%; 
  font-family: Arial, Helvetica, sans-serif;
  font-size: 15px;
  padding: 0;
  color: #E7E8E8;
  margin: 0px 15px 0px 0px;
}

.promotion-channels-input {
  margin-bottom: 0; 
  border: none; 
  padding: 0;
  font-size: 15px;
}

.phone-lines-input {
  margin-bottom: 0; 
  border: none; 
  padding: 0;
  font-size: 15px;
}

.delivery-date-input {
  font-size: 15px !important;
}

.delivery-date-input::placeholder {
  font-size: 15px !important;
}

.total-wrap {
  font-family: Arial, Helvetica, sans-serif;
  font-size: 14px !important;
  color: #73777B !important; 
  margin-right: 34px
}

.total-value {
  margin-left: 5px;
  font-size: 14px;
}

.top-right-rounded {
  border-top-right-radius: 5px;
}

.minus-div {
  width: 34px !important;
}

.select:hover {
  border: none;
}

.section-wrap {
  width: calc(50% - 5px) !important;
}

.align-between {
  width: 100%; 
  display: flex; 
  flex-direction: row;
  justify-content: space-between;
}
</style>